export default __webpack_public_path__ + "static/media/image2tum.dc4494a7.jpg";